import React, { useRef, useState } from 'react';
import { Icon, IconsEnum, toIconsEnum } from 'components/Icons';

import { TooltipProps } from 'components/tooltip';
import styles from './Tooltip.module.scss';
import { useOutsideAlerter } from 'hooks/useClickOutside';
import classNames from 'classnames';

export const Tooltip = ({
  content,
  iconColor,
  iconId,
  position,
  children,
  isClicked,
  forceActive,
  stateOnClick,
  childrenColor,
  iconClassName,
  containerClassName,
  setIsClicked,
  setStateOnClick,
}: TooltipProps) => {
  const [active, setActive] = useState(false);
  const wrapperRef = useRef<HTMLButtonElement>(null);

  const showTip = () => {
    setActive(true);
    setIsClicked && setIsClicked(true);
  };

  const hideTip = () => {
    setActive(false);
    setIsClicked && setIsClicked(false);
  };

  useOutsideAlerter({
    ref: wrapperRef,
    onClickOutside: () => {
      setActive(false);
      setStateOnClick && setStateOnClick(false);
      setIsClicked && setIsClicked(false);
    },
  });

  return (
    <button
      type="button"
      onMouseEnter={() => {
        showTip();
        setStateOnClick && setStateOnClick(true);
        setIsClicked && setIsClicked(true);
      }}
      onMouseLeave={() => {
        hideTip();
        setStateOnClick && setStateOnClick(false);
        setIsClicked && setIsClicked(false);
      }}
      onClick={() => {
        console.log('Tooltip', isClicked, setIsClicked);
        setActive(!active);
        setStateOnClick && setStateOnClick(!stateOnClick);
        setIsClicked && setIsClicked(!isClicked);
      }}
      className={classNames(styles.iconWrapper, { [styles.active]: active })}
      style={{ alignItems: children ? 'flex-end' : '' }}
      ref={wrapperRef}
      suppressHydrationWarning
    >
      <Icon
        iconId={iconId ? toIconsEnum(iconId) : IconsEnum.INFO}
        className={classNames(styles.titleIcon, iconClassName ?? '')}
        color={`var(${iconColor ? iconColor : '--color-neutral-01'})`}
        suppressHydrationWarning
      />
      <div
        className={classNames(styles.tooltip, position ? styles[position] : styles.top, containerClassName ?? '', {
          [styles.activeTooltip]: active,
          [styles.alwaysActive]: forceActive,
        })}
        suppressHydrationWarning
      >
        {content}
      </div>
      {children && (
        <p
          suppressHydrationWarning
          style={{ color: `var(${childrenColor} ? childrenColor : '--color-on-bg-primary')` }}
        >
          {children}
        </p>
      )}
    </button>
  );
};